module.exports = __webpack_public_path__ + "static/media/homebanner.107f3c09.png";